import React from "react";
import { Container, Typography, Box, Paper, List, ListItem, ListItemIcon, ListItemText, Divider, Button } from "@mui/material";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTree, faGavel, faExclamationTriangle, faBookOpen, faUserShield, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { faHandshake } from "@fortawesome/free-regular-svg-icons";

const bulletPoints = [
    {
        icon: faTree,
        text: "le choix du Maire de détruire le Bois de la Source pour construire la crèche,"
    },
    {
        icon: faExclamationTriangle,
        text: "des finances exsangues faute de pilotage rigoureux,"
    },
    {
        icon: faGavel,
        text: "le fiasco du projet BLR2030 (des dizaines de milliers d'euros dilapidés !),"
    },
    {
        icon: faBookOpen,
        text: "la construction d'une médiathèque non conforme à la réglementation thermique actuelle et très chère,"
    },
    {
        icon: faUserShield,
        text: "le sketch de la fiche communale du PLH soi-disant rejetée par le Maire mais qui a voté pour en conseil d'agglomération,"
    },
    {
        icon: faExclamationTriangle,
        text: "des méthodes antidémocratiques et une gestion obscure des affaires communales."
    }
];

const engagements = [
    {
        icon: faTree,
        title: "Préservation de la qualité de vie & environnement",
        text: <>Urbanisme maîtrisé, développement durable, protection de la biodiversité et des espaces naturels pour que Bois-le-Roi reste ce lieu où il fait bon vivre.</>
    },
    {
        icon: faHandshake,
        title: "Démocratie, transparence & engagement citoyen",
        text: <>Informer honnêtement, organiser de vrais débats avec les habitants et associations : écouter, consulter, impliquer. Œuvrer pour que la démocratie locale s’exerce réellement.</>
    }
];

const POST20230706: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
            <Box mt={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    Création de l&apos;association « Vivre la démocratie à BLR »
                </Typography>
            </Box>

            <Paper elevation={2} sx={{ p: 3, mt: 3, background: "linear-gradient(120deg,#f8fafc 60%, #e3edfd 100%)" }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    L&apos;histoire de <b>« Vivre la démocratie à BLR »</b> commence en novembre 2021, lorsque nous avions dû alerter et mobiliser les habitants contre le projet du Maire de donner carte blanche à l’EPFIF sur quasiment toute la commune : un projet d’urbanisme à forts enjeux, non prévu ni anticipé, que le Maire avait dissimulé à sa propre majorité.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Depuis, plusieurs épisodes ont démontré la nécessité de rester mobilisés :
                </Typography>
                <List>
                    {bulletPoints.map(({icon, text}, i) => (
                        <ListItem key={i} sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={icon} color="#1976d2" />
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    <b>Aujourd&apos;hui, nous avons le plaisir de vous annoncer la création de l&apos;association « Vivre la démocratie à BLR »</b> pour renforcer notre action au bénéfice des habitants et de l&apos;avenir de Bois-le-Roi.
                </Typography>
                <Typography variant="subtitle1" color="primary" sx={{ mt: 2, fontWeight: 700 }}>
                    Nos engagements :
                </Typography>
                <Box display="flex" flexDirection={{xs: "column", sm: "row"}} gap={2} mt={1}>
                    {engagements.map(({icon, title, text}, i) => (
                        <Paper key={i} elevation={0} sx={{ flex: 1, p: 2, background: "#fff", border: "1px solid #e3e3e3" }}>
                            <Box display="flex" alignItems="center" mb={1}>
                                <FontAwesomeIcon icon={icon} color="#388e3c" size="lg" style={{ marginRight: 8 }} />
                                <Typography fontWeight={600}>{title}</Typography>
                            </Box>
                            <Typography variant="body2">{text}</Typography>
                        </Paper>
                    ))}
                </Box>
                <Typography variant="body1" sx={{ my: 2 }}>
                    À partir d’une lecture croisée de l’écoute citoyenne, du respect de l’environnement, du cadre de vie et de la mise en application des principes démocratiques sur notre commune, nous œuvrons à la défense des intérêts locaux, et pour que la démocratie puisse s’exercer.
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box textAlign="center" mt={2}>
                    <Typography variant="h6" fontWeight={700}>
                        <FontAwesomeIcon icon={faArrowRightLong} style={{ marginRight: 8, color: "#1976d2" }} />
                        Envie de participer ?
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                        Vous souhaitez élaborer des alternatives politiques et porter la voix de la démocratie locale ?
                        <br />
                        <b>Rejoignez l&apos;association « Vivre la démocratie à BLR »</b> pour préserver Bois-le-Roi et retrouver une respiration démocratique.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default POST20230706;